import { createFileRoute } from "@tanstack/react-router";
import SupplierPreviewPage from "@/features/public/pages/tools/supplier-preview";

export const Route = createFileRoute("/(public)/_public/tools/supplier-preview")({
  component: SupplierPreviewPage,
});
